import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { PageWrapper } from 'Views/Components/PageWrapper/PageWrapper';
import Icon from 'Views/Components/_HumanWritten/Icon/Icon';
import { RenderClearCacheModal } from 'Views/Components/_HumanWritten/Modal/ClearCacheModal';
import { alertModal } from 'Views/Components/Modal/ModalUtils';
import Card from '../../Components/Card/Card';
import CardGroup from '../../Components/Card/CardGroup';
import { store } from 'Models/Store';
import alertToast from '../../../Util/ToastifyUtils';
import { ROUTES } from 'Constants';

const AdminPage = observer(() => {
	const [loading, setLoading] = React.useState(false);

	const clearCache = async () => {
		setLoading(true);
		try {
			await RenderClearCacheModal();
			alertToast('Successfully cleared cache.', 'success');
		} catch (e) {
			// Do nothing
		}
		setLoading(false);
	};

	return (
		<PageWrapper>
			<div className="mx-auto max-w-5xl px-6 py-8">
				<header className="mb-8 flex flex-wrap items-center justify-between gap-3">
					<h1 className="text-2xl font-semibold text-gray-900">Admin Dashboard</h1>
					<div className="flex items-center gap-3">
						<span
							className={
								'inline-flex items-center gap-2 rounded-full bg-gray-100 ' +
								'px-3 py-1 text-sm text-gray-600'
							}
						>
							Version
							<span className="font-medium text-gray-900">{store.buildVersion.version}</span>
						</span>
						<Link
							to="/logout"
							className={
								'inline-flex items-center gap-1.5 rounded-md border border-gray-300 ' +
								'px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50'
							}
						>
							<Icon name="logout" useMaterialIcons classname="text-base leading-none" />
							Logout
						</Link>
					</div>
				</header>

				<CardGroup>
					{store.isSuper && (
						<Card
							icon={<Icon name="api" useMaterialIcons />}
							title="View OpenAPI"
							description="View the app's swagger docs and the structure of the API."
							href="/api/swagger"
						/>
					)}
					{store.isSuper && (
						<Card
							icon={<Icon name="manage_history" useMaterialIcons />}
							title="Hangfire"
							description="View and manage background jobs and recurring tasks."
							href="/api/hangfire"
						/>
					)}
					{store.isSuper && (
						<Card
							makeButton
							disabled={loading}
							onClick={clearCache}
							icon={<Icon name="delete" useMaterialIcons />}
							iconClassName="bg-red-50 text-red-600 group-hover:bg-red-100"
							title={loading ? 'Clearing cache...' : 'Clear cache'}
							description="Clear cached data from redis. For use when data is not appearing correctly."
						/>
					)}
					{store.isAdmin && (
						<Card
							icon={<Icon name="mail" useMaterialIcons />}
							title="Trapped communications"
							description="View every email and SMS the system has attempted to send."
							href={`/admin-backend/${ROUTES.ADMIN.TRAPPED_COMMUNICATIONS}`}
							target="_self"
						/>
					)}
					{store.isSuper && (
						<Card
							icon={<Icon name="widgets" useMaterialIcons />}
							title="Component Library"
							description="View all input components, buttons, modals and tables used across the app."
							href="/component-library"
						/>
					)}
				</CardGroup>
			</div>
		</PageWrapper>
	);
});

export default AdminPage;
